define('collections/onboarding/tutorials',[
    'underscore',
    'backbone',
    'utils',
    'moment',
    // custom
    'services/api',
    // models
    'models/onboarding/tutorial'
], function(
    _, Backbone, U, moment,
    API,
    MOnboardingTutorial
) {

    var COnboardingTutorials = Backbone.Collection.extend({
        model: MOnboardingTutorial,
        fetchDelay: 5,

        url: function() {
            return API.url('onboarding-tutorials/');
        },

        initialize: function(models, opt) {
            this.readyPromise = Backbone.$.Deferred();
        },

        ready: function() {
            return this.readyPromise;
        },

        /**
         * False if the promise is pending, or the last fetch was within the delay.
         * Force a new fetch if the lang has changed since the last fetch.
         * @return {Boolean} fetch is needed
         */
        isFetchDue: function() {
            var lastFetch = this.lastFetch,
                promise = this.promise,
                isPending = promise && promise.state() === "pending";

            return !isPending && !lastFetch || // not fetched yet?
                moment().diff(lastFetch, 'seconds') > this.fetchDelay; // is delay passed?
        },

        fetch: function(options) {
            options = options || {};
            if (this.isFetchDue() || options.force) {
                var promise = this.promise = COnboardingTutorials.__super__.fetch.call(this, {
                    context: this,
                    success: this._onSync,
                    error: this._onError
                }).then(
                    function() {
                        this.ready().resolve();
                    },
                    function() {
                        this.ready().reject();
                    }
                );
            }
            return this.promise;
        },

        _onSync: function() {
            this.lastFetch = moment();
        },
        _onError: function() {
            this.lastFetch = null;
        },
    });

    var tutorials = new COnboardingTutorials();

    return tutorials;
});

